module.exports = __webpack_public_path__ + "static/media/cross-clock.30fcb6c9.svg";